class EventBusEmitter {
  constructor () {
    this.listeners = new Map();
  }

  $on (event, handler) {
    if (!event || typeof handler !== 'function') {
      return () => {};
    }
    const handlers = this.listeners.get(event) || new Set();
    handlers.add(handler);
    this.listeners.set(event, handlers);
    return () => this.$off(event, handler);
  }

  $off (event, handler) {
    if (!event) {
      this.listeners.clear();
      return;
    }

    const handlers = this.listeners.get(event);
    if (!handlers) {
      return;
    }

    if (!handler) {
      this.listeners.delete(event);
      return;
    }

    handlers.delete(handler);
    if (handlers.size === 0) {
      this.listeners.delete(event);
    }
  }

  $once (event, handler) {
    if (!event || typeof handler !== 'function') {
      return () => {};
    }

    const onceHandler = (...args) => {
      this.$off(event, onceHandler);
      handler(...args);
    };

    return this.$on(event, onceHandler);
  }

  $emit (event, ...args) {
    const handlers = this.listeners.get(event);
    if (!handlers || handlers.size === 0) {
      return;
    }

    [...handlers].forEach(handler => {
      handler(...args);
    });
  }
}

export const EventBus = new EventBusEmitter();
